import { ReportStatus } from 'src/graphql';

export const isCloseBlockedByCountryRegion = (
  requireCountryRegionForClose: boolean,
  isCountryRegionMissing: boolean,
  status: string | number | boolean,
): boolean =>
  requireCountryRegionForClose &&
  isCountryRegionMissing &&
  status === ReportStatus.Closed;
